import { styled } from '@mui/material'
import { COLUMN_SEPARATOR_WIDTH, MAX_COLUMN_WIDTH, MIN_COLUMN_WIDTH } from '../PageTemplate/constants'

type PageColumnProps = {
    children?: React.ReactNode
    fullWidth?: boolean
    maxColumnWidth?: boolean
    withoutMaxWidth?: boolean
}

export default function PageColumn({ children, fullWidth = false, maxColumnWidth = false, withoutMaxWidth = false }: PageColumnProps) {
    return (
        <ColumnContainer fullWidth={fullWidth} maxColumnWidth={maxColumnWidth} withoutMaxWidth={withoutMaxWidth}>
            {children}
        </ColumnContainer>
    )
}

const ColumnContainer = styled('div', {
    shouldForwardProp: (prop) => prop !== 'fullWidth' && prop !== 'maxColumnWidth' && prop !== 'withoutMaxWidth',
})<Omit<PageColumnProps, 'children'>>(({ theme, fullWidth, maxColumnWidth, withoutMaxWidth }) => ({
    width: fullWidth || maxColumnWidth ? '100%' : `calc((100% - ${COLUMN_SEPARATOR_WIDTH}px) / 2)`,
    minWidth: `${MIN_COLUMN_WIDTH}px`,
    maxWidth: fullWidth || withoutMaxWidth ? '100%' : `${MAX_COLUMN_WIDTH}px`,
    [theme.breakpoints.down('singleColumn')]: {
        width: `100%`,
    },
}))
